// extracted by mini-css-extract-plugin
export default {"header-wrapper":"TopicHeader_header-wrapper__pIV-K","header-image":"TopicHeader_header-image__bMwap","reverse-order":"TopicHeader_reverse-order__EudOS"};